export const CITIES = [
  {
    slug: "portland",
    name: "Portland",
    blurb: "From Laurelhurst craftsmans to St. Johns bungalows, Portland's older homes rely on masonry chimneys that take a beating from our wet winters.",
    neighborhoods: ["Laurelhurst", "St. Johns", "Sellwood", "Alberta", "Irvington", "Lents"],
  },
  {
    slug: "hillsboro",
    name: "Hillsboro",
    blurb: "Hillsboro's mix of farmhouse-era and newer homes means everything from century-old brick stacks to modern factory-built chimneys.",
    neighborhoods: ["Orenco Station", "Tanasbourne", "Reedville", "Downtown Hillsboro", "AmberGlen"],
  },
  {
    slug: "clackamas",
    name: "Clackamas",
    blurb: "Clackamas homes see long, damp winters — prime conditions for creosote buildup and masonry wear.",
    neighborhoods: ["Happy Valley", "Sunnyside", "Oak Grove", "Carver", "Clackamas Town Center"],
  },
  {
    slug: "beaverton",
    name: "Beaverton",
    blurb: "Beaverton's established neighborhoods are full of wood-burning fireplaces that work hard from October through April.",
    neighborhoods: ["Cedar Hills", "Aloha", "Murrayhill", "Downtown Beaverton", "Sexton Mountain"],
  },
  {
    slug: "tualatin",
    name: "Tualatin",
    blurb: "Tualatin's rainy season puts constant pressure on crowns, caps, and flashing — the first places water finds its way in.",
    neighborhoods: ["Tualatin Commons", "Fox Hill", "Victoria Woods", "Ibach", "Durham"],
  },
];

export const SERVICES_SEO = [
  {
    slug: "chimney-sweeping",
    name: "Chimney Sweeping",
    photoTitle: "Chimney Sweeping",
    offer: "$249 Special — Free Inspection Included",
    leadService: "Chimney Sweeping ($249 Special)",
    intro: (city) =>
      `Our $249 chimney sweeping special in ${city} includes a complete professional sweep plus a free, top-to-bottom inspection of your flue, crown, cap, and flashing. We remove dangerous creosote, soot, and blockages so your fireplace burns clean and safe.`,
    keywordPara: (city) =>
      `Searching for a "chimney sweep near me" in ${city}? Homeowners across ${city} call Exotictileandmasonry for chimney cleaning, creosote removal, fireplace cleaning, chimney inspections, and annual chimney safety checks — all backed by our $249 sweep-and-inspect special.`,
    bullets: [
      "Full flue sweep with professional rotary equipment",
      "Free top-to-bottom safety inspection included",
      "Mess-free service — we leave your home spotless",
    ],
  },
  {
    slug: "chimney-repair",
    name: "Chimney Repair",
    photoTitle: null,
    offer: null,
    leadService: "Chimney Repair",
    intro: (city) =>
      `Cracked flue liners, spalling brick, leaning stacks — we diagnose and repair structural chimney problems in ${city} before they threaten your home's safety.`,
    keywordPara: (city) =>
      `Need "chimney repair near me" in ${city}? We handle chimney leak repair, chimney masonry repair, chimney rebuilds, flue liner repair, and chimney inspection repairs — including real estate escrow and home inspection punchlist chimney repairs with callback within 24 hours.`,
    bullets: [
      "Honest diagnosis with photo documentation",
      "Structural masonry and flue repairs",
      "Fair, written quotes before any work begins",
    ],
  },
  {
    slug: "chimney-crowns",
    name: "Chimney Crowns",
    photoTitle: "Crown Repair & Rebuild",
    offer: null,
    leadService: "Chimney Crown",
    intro: (city) =>
      `We rebuild cracked, moss-eaten chimney crowns in ${city} with a fresh mortar wash that sheds water instead of soaking it in — protecting the entire stack below.`,
    keywordPara: (city) =>
      `For chimney crown repair and chimney crown replacement in ${city}, our masons rebuild failing crowns with proper drip edges and sealed finishes. If you see cracks, moss, or water stains near your chimney top, a crown rebuild stops the damage before it reaches the flue.`,
    bullets: [
      "Damaged crown fully removed",
      "New crown formed and poured with a proper drip edge",
      "Sealed against Oregon's wet winters",
    ],
  },
  {
    slug: "chimney-caps",
    name: "Chimney Caps",
    photoTitle: null,
    offer: null,
    leadService: "Chimney Cap",
    intro: (city) =>
      `A quality chimney cap keeps rain, animals, and debris out of your ${city} home's flue while improving draft and spark protection.`,
    keywordPara: (city) =>
      `Looking for "chimney cap installation near me" in ${city}? We install and replace chimney caps, chimney rain caps, and animal guards — sized and fitted to your exact flue, with stainless options that outlast Oregon weather.`,
    bullets: [
      "Stainless and galvanized options",
      "Sized and fitted to your exact flue",
      "Keeps out raccoons, birds, and rain",
    ],
  },
  {
    slug: "chimney-flashing",
    name: "Chimney Flashing",
    photoTitle: null,
    offer: null,
    leadService: "Chimney Flashing",
    intro: (city) =>
      `Leaky chimney flashing is the number one source of chimney leaks in ${city}. We repair and replace the seal where your chimney meets the roof.`,
    keywordPara: (city) =>
      `For chimney flashing repair and chimney leak repair in ${city}, we replace step and counter flashing, reseal the chimney-to-roof joint, and stop water stains on ceilings and walls around your fireplace.`,
    bullets: [
      "Precise leak source detection",
      "Step and counter flashing replacement",
      "Sealed to withstand heavy PNW rain",
    ],
  },
  {
    slug: "tuckpointing-chase-covers",
    name: "Tuckpointing & Chase Covers",
    photoTitle: "Chase Cover & Tuckpointing",
    offer: null,
    leadService: "Tuckpointing",
    intro: (city) =>
      `We restore failing mortar joints and replace rusted chase covers on ${city} chimneys — stopping water intrusion and renewing the look of your brickwork.`,
    keywordPara: (city) =>
      `Searching for "tuckpointing near me" or chimney chase cover replacement in ${city}? We repoint crumbling mortar with color-matched mixes, repair chimney masonry, and fit new metal chase covers that end rust streaks and leaks for good.`,
    bullets: [
      "Precision mortar joint repointing",
      "New metal chase covers and caps",
      "Color-matched mortar for a seamless look",
    ],
  },
  {
    slug: "fireplace-glass-doors",
    name: "Fireplace Glass Door Installation",
    photoTitle: "Fireplace Glass Door Installation",
    offer: null,
    leadService: "Other / Not Sure",
    intro: (city) =>
      `Custom-fit fireplace glass door installation in ${city} for a cleaner hearth, better draft control, and a safer fireplace your family can gather around.`,
    keywordPara: (city) =>
      `For fireplace glass door installation in ${city}, we measure your firebox opening and fit doors that match your hearth style — improving draft control, efficiency, and safety for homes across the area.`,
    bullets: [
      "Measured for a custom fit",
      "Modern and traditional styles available",
      "Improves efficiency and safety",
    ],
  },
  {
    slug: "emergency-escrow-chimney-service",
    name: "Emergency Escrow Chimney Service",
    photoTitle: null,
    offer: "Callback Within 24 Hours — Service Within 48",
    leadService: "Other / Not Sure",
    intro: (city) =>
      `Real estate escrow and home inspection punchlist experts serving ${city}. When a chimney issue lands on the inspection report, we move fast — callback within 24 hours, service within 48, with photo documentation your agent can drop straight into the escrow file.`,
    keywordPara: (city) =>
      `For escrow chimney repair in ${city}, emergency chimney service, and home inspection punchlist chimney work, we offer callback within 24 hours and service within 48 hours. Realtors, buyers, and sellers trust us to clear chimney punchlist items fast — repairs, sweeps, and inspections with written documentation for escrow.`,
    bullets: [
      "Callback within 24 hours, service within 48 hours",
      "Home inspection punchlist chimney repairs",
      "Photo documentation for escrow files and agents",
    ],
  },
];
